import { render } from "./BaseNav.vue?vue&type=template&id=8e589b34"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__